import Avatar from 'funifier-nice-avatar';

import { iniciaisDoFunci } from '../feed-calculos';

interface AvatarDoFunciProps {
  nomeDeGuerra?: string;
  /** Classe de fundo das iniciais (ver `corDoFunci`). */
  cor: string;
  /** Diâmetro em px. */
  tamanho: number;
  /** Classe do tamanho da fonte das iniciais. */
  fonte: string;
  dados?: { avatar_type?: number; avatar?: unknown; image?: { medium?: { url?: string }; small?: { url?: string } } };
}

/**
 * Avatar do Feed: a foto quando a pessoa usa imagem, o avatar montado quando existe
 * e, sem nenhum dos dois, as iniciais sobre a cor do design. Decorativo: o nome da
 * pessoa sempre aparece em texto ao lado.
 */
export default function AvatarDoFunci({ nomeDeGuerra, cor, tamanho, fonte, dados }: AvatarDoFunciProps) {
  const medida = { width: tamanho, height: tamanho };
  const foto = dados?.avatar_type === 1 ? dados.image?.medium?.url || dados.image?.small?.url : undefined;

  if (foto) {
    return <img src={foto} alt="" aria-hidden="true" style={medida} className="block shrink-0 rounded-full object-cover" />;
  }

  if (!dados?.avatar_type && dados?.avatar) {
    return (
      <span aria-hidden="true" style={medida} className="block shrink-0 overflow-hidden rounded-full">
        <Avatar style={medida} {...(dados.avatar as object)} />
      </span>
    );
  }

  return (
    <span
      aria-hidden="true"
      style={medida}
      className={`flex shrink-0 items-center justify-center rounded-full font-display font-extrabold text-brand-navy ${fonte} ${cor}`}
    >
      {iniciaisDoFunci(nomeDeGuerra)}
    </span>
  );
}
